import { render, staticRenderFns } from "./PopupCopyWeek.vue?vue&type=template&id=1550dbbd&scoped=true&"
import script from "./PopupCopyWeek.vue?vue&type=script&lang=js&"
export * from "./PopupCopyWeek.vue?vue&type=script&lang=js&"
import style0 from "./PopupCopyWeek.vue?vue&type=style&index=0&id=1550dbbd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1550dbbd",
  null
  
)

export default component.exports